import { Model, Request } from '@viddsee/server-api-client/types';
import { videosApi } from '@/scripts/webcall/v3/videos';
import { filmReviewQuestionsApi } from '@/scripts/webcall/v3/filmReviewQuestion';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createWebcall = ({ videoId }: { videoId: string }) => ({
  async checkReviewStatus(): Promise<{ hasReviewed: boolean }> {
    const { data } = await videosApi.getInteractions({ videoId }, undefined);
    return { hasReviewed: data.hasReviewed };
  },

  async getQuestions(): Promise<Model.Pagination.ItemsCountedResponse<Model.FilmReviewQuestion.Info>> {
    const { data } = await filmReviewQuestionsApi.list();
    return data;
  },

  async answerQuestions(responses: Request.Videos.ReviewRequestBody['responses']): Promise<Model.Video.ReviewResponse> {
    const { data } = await videosApi.review({ videoId }, undefined, { responses });
    return data;
  },
});

export type FilmReviewServiceWebcall = ReturnType<typeof createWebcall>;
